import { render, staticRenderFns } from "./ParcelNumber.vue?vue&type=template&id=c25d8510"
import script from "./ParcelNumber.vue?vue&type=script&lang=js"
export * from "./ParcelNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c25d8510')) {
      api.createRecord('c25d8510', component.options)
    } else {
      api.reload('c25d8510', component.options)
    }
    module.hot.accept("./ParcelNumber.vue?vue&type=template&id=c25d8510", function () {
      api.rerender('c25d8510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/LogisticsTable/ParcelNumber.vue"
export default component.exports